__turbopack_context__.v({
  "className": "archivo_477669b6-module__sXqP8W__className",
});
